<template>
  <div class="page-wrapper">
    <menu-dispatcher></menu-dispatcher>

    <div class="wrapper">
      <header-dispatcher></header-dispatcher>
      <div class="screen-container">
        <div class="center-content">
          <div class="content-box">
            <div class="content-head">
              <div class="title">
                <router-link to="/directories/trucking-categories">
                  <a class="back" title="Назад"><img src="../image/back.png"></a>
                </router-link>
                {{ isNew ? 'Добавить' : 'Редактировать' }}
              </div>
              <div class="cabinet-body"></div>
            </div>
            <div class="content-body directorys-page">
              <div class="cabinet-info">
                <div class="directory-box">
                  <div class="main-content">
                    <div class="head-panel visibility">
                      <span class="table-string-delete" v-show="!isNew" @click="remove"><i class="fa fa-trash-o"></i>Удалить строку</span>
                    </div>
                    <div class="form">
                      <div class="fieldset">
                        <label class="fieldset-title">Наименование</label>
                        <fieldset :class="{'fieldset-error': errors.has('name')}">
                          <input type="text" v-model="name" v-validate="'required'" :class="{'input': true}"
                                 name="name">
                          <span v-show="errors.has('name')" class="error-text">Заполните обязательное поле</span>
                        </fieldset>

                      </div>
                      <div class="fieldset">
                        <label class="fieldset-title">Цена часовая, руб.</label>
                        <fieldset :class="{'fieldset-error': errors.has('hourPrice')}">
                          <input type="number" v-model="hourPrice" v-validate="'required'" :class="{'input': true}"
                                 name="hourPrice">
                          <span v-show="errors.has('hourPrice')" class="error-text">Заполните обязательное поле</span>
                        </fieldset>
                      </div>
                      <div class="fieldset">
                        <label class="fieldset-title">Цена километраж, руб.</label>
                        <fieldset :class="{'fieldset-error': errors.has('kmPrice')}">
                          <input type="number" v-model="kmPrice" v-validate="'required'" :class="{'input': true}"
                                 name="kmPrice">
                          <span v-show="errors.has('kmPrice')" class="error-text">Заполните обязательное поле</span>
                        </fieldset>
                      </div>
                      <div class="fieldset">
                        <label class="fieldset-title">Зар. плата часовая, руб.</label>
                        <fieldset :class="{'fieldset-error': errors.has('hourSalary')}">
                          <input type="number" v-model="hourSalary" v-validate="'required'" :class="{'input': true}"
                                 name="hourSalary">
                          <span v-show="errors.has('hourSalary')" class="error-text">Заполните обязательное поле</span>
                        </fieldset>
                      </div>
                      <div class="fieldset">
                        <label class="fieldset-title">Зар. плата за километр, руб.</label>
                        <fieldset :class="{'fieldset-error': errors.has('kmSalary')}">
                          <input type="number" v-model="kmSalary" v-validate="'required'" :class="{'input': true}"
                                 name="kmSalary">
                          <span v-show="errors.has('kmSalary')" class="error-text">Заполните обязательное поле</span>
                        </fieldset>
                      </div>
                      <div class="fieldset">
                        <label class="fieldset-title">Минимальная продолжительность, час.</label>
                        <fieldset :class="{'fieldset-error': errors.has('minDuration')}">
                          <input type="number" v-model="minDuration"
                                 v-validate="'required'" :class="{'input': true}" name="minDuration">
                          <span v-show="errors.has('minDuration')" class="error-text">Заполните обязательное поле</span>
                        </fieldset>
                      </div>
                      <div class="cashless-block">
                        <div class="fieldset">
                          <div class="title">Надбавка за безнал</div>
                        </div>
                        <div class="fieldset">
                          <label class="fieldset-title">Надбавка часовая, руб.</label>
                          <fieldset :class="{'fieldset-error': errors.has('hourPriceSurchargeByCashless')}">
                            <input type="number" v-model="hourPriceSurchargeByCashless"
                                   v-validate="'required'" :class="{'input': true}" name="hourPriceSurchargeByCashless">
                            <span v-show="errors.has('hourPriceSurchargeByCashless')" class="error-text">Заполните обязательное поле</span>
                          </fieldset>
                        </div>
                        <div class="fieldset">
                          <label class="fieldset-title">Надбавка километраж, руб.</label>
                          <fieldset :class="{'fieldset-error': errors.has('kmPriceSurchargeByCashless')}">
                            <input type="number" v-model="kmPriceSurchargeByCashless"
                                   v-validate="'required'" :class="{'input': true}" name="kmPriceSurchargeByCashless">
                            <span v-show="errors.has('kmPriceSurchargeByCashless')" class="error-text">Заполните обязательное поле</span>
                          </fieldset>
                        </div>
                      </div>
                      <div class="buttons">
                        <button type="button" class="save-button" @click="save">
                          Сохранить
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import MenuDispatcher from '@/components/MenuDispatcher.vue'
    import HeaderDispatcher from '@/components/HeaderDispatcher.vue'
    import api from '@/api'
    import VeeValidate from 'vee-validate'

    export default {
  name: 'TruckingCategory',
  components: {
    MenuDispatcher,
    HeaderDispatcher,
    VeeValidate
  },

  data () {
    return {
      id: null,
      isNew: false,
      truckingCategory: {},
      newTruckingCategory: {}
    }
  },

  computed: {
    name: {
      get () {
        return !this.isNew ? this.truckingCategory.name : this.newTruckingCategory.name
      },

      set (name) {
        !this.isNew ? this.truckingCategory.name = name : this.newTruckingCategory.name = name
      }
    },
    hourPrice: {
      get () {
        return !this.isNew ? this.truckingCategory.hourPrice : this.newTruckingCategory.hourPrice
      },

      set (hourPrice) {
        !this.isNew ? this.truckingCategory.hourPrice = hourPrice : this.newTruckingCategory.hourPrice = hourPrice
      }
    },
    kmPrice: {
      get () {
        return !this.isNew ? this.truckingCategory.kmPrice : this.newTruckingCategory.kmPrice
      },

      set (kmPrice) {
        !this.isNew ? this.truckingCategory.kmPrice = kmPrice : this.newTruckingCategory.kmPrice = kmPrice
      }
    },
    hourSalary: {
      get () {
        return !this.isNew ? this.truckingCategory.hourSalary : this.newTruckingCategory.hourSalary
      },

      set (hourSalary) {
        !this.isNew ? this.truckingCategory.hourSalary = hourSalary : this.newTruckingCategory.hourSalary = hourSalary
      }
    },
    kmSalary: {
      get () {
        return !this.isNew ? this.truckingCategory.kmSalary : this.newTruckingCategory.kmSalary
      },

      set (kmSalary) {
        !this.isNew ? this.truckingCategory.kmSalary = kmSalary : this.newTruckingCategory.kmSalary = kmSalary
      }
    },
    minDuration: {
      get () {
        return !this.isNew ? this.truckingCategory.minDuration : this.newTruckingCategory.minDuration
      },

      set (minDuration) {
        !this.isNew ? this.truckingCategory.minDuration = minDuration : this.newTruckingCategory.minDuration = minDuration
      }
    },

    kmPriceSurchargeByCashless: {
      get () {
        return !this.isNew ? this.truckingCategory.kmPriceSurchargeByCashless : this.newTruckingCategory.kmPriceSurchargeByCashless
      },

      set (kmPriceSurchargeByCashless) {
        !this.isNew ? this.truckingCategory.kmPriceSurchargeByCashless = kmPriceSurchargeByCashless
          : this.newTruckingCategory.kmPriceSurchargeByCashless = kmPriceSurchargeByCashless
      }
    },

    hourPriceSurchargeByCashless: {
      get () {
        return !this.isNew ? this.truckingCategory.hourPriceSurchargeByCashless : this.newTruckingCategory.hourPriceSurchargeByCashless
      },

      set (hourPriceSurchargeByCashless) {
        !this.isNew ? this.truckingCategory.hourPriceSurchargeByCashless = hourPriceSurchargeByCashless
          : this.newTruckingCategory.hourPriceSurchargeByCashless = hourPriceSurchargeByCashless
      }
    }
  },

  mounted () {
    let body = document.getElementsByTagName('body')[0]
    body.classList.add('cabinet-page')

    this.id = this.$route.params.id
    if (this.id == 'new') {
      this.isNew = true
      this.newTruckingCategory = {
        name: null,
        hourPrice: null,
        kmPrice: null,
        hourSalary: null,
        kmSalary: null,
        minDuration: null,
        kmPriceSurchargeByCashless: null,
        hourPriceSurchargeByCashless: null
      }
    } else {
      api
        .getTruckingCategoryById(this.id)
        .then(truckingCategory => {
          if (truckingCategory) {
            this.truckingCategory = truckingCategory
            this.isNew = false
          }
        })
    }
  },

  destroyed () {
    let body = document.getElementsByTagName('body')[0]
    body.classList.remove('cabinet-page')
  },

  methods: {
    remove () {
      this.truckingCategory.removed = true
      this.save()
    },

    save () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.$store.getters.waitingApiRequestsCount != 0) { return }

          this.isNew
            ? api
              .createTruckingCategory(this.newTruckingCategory)
              .then(() => {
                this.$router.push('/directories/trucking-categories')
                alert('Сохранено')
              })
              .catch(err => alert(err))
            : api
              .updateTruckingCategory(this.id, this.truckingCategory)
              .then(() => {
                this.$router.push('/directories/trucking-categories')
                alert('Сохранено')
              })
              .catch(err => alert(err))
        }
      })
    }
  }
}
</script>
